import { ReactElement } from "react";

import styles from "./index.module.css";

export default function TwoColSection(props: {
  children: { left?: ReactElement; right?: ReactElement }[];
}): ReactElement {
  return (
    <div className={styles.wrapper}>
      {props.children.map((child, i) => (
        <div key={i} style={{ display: "contents" }}>
          <div>{child.left}</div>
          <div className={styles.right}>{child.right}</div>
        </div>
      ))}
    </div>
  );
}
